export default __webpack_public_path__ + "static/media/TDPS_PORTAL_AssetTransferUpload.0f0854ec.xlsx";